/**
 * Service: ticketConfig
 */
angular.module('acme.common.service.ticketConfig', [])
.service('TicketConfigService', [function() {

    return {

      model: {},
      layout: {
        tickets: [
          { name: 'Theme', value: 'theme'},
          { name: 'Custom', value: 'custom'}
        ],
        schedules: [
          { name: 'Theme', value: 'theme'},
          { name: 'Selected ticket layout', value: 'settings'},
          { name: 'Custom', value: 'custom'}

        ],
        events: [
          { name: 'Schedule', value: 'schedule'},
          { name: 'Selected ticket layout', value: 'settings'},
          { name: 'Custom', value: 'custom'}
        ]
      },

      init: function() {
        return true;
      },

      resetModel: function() {
        this.model = {};
      },

      getModel: function() {
        return this.model;
      },

      setModel: function(model) {
        this.model = model;
      },

      getLayout: function(type) {
        return this.layout[type];
      }

    };

}]);